module.exports = __webpack_public_path__ + "img/3화_16(3).297ea546.png";